<template>
    <div class="form-container">
        <b-row>
            <b-col cols="12">
                <b-card>
                    <div slot="header">
                        <strong>Template Information</strong>
                    </div>
                    <div class="form-container">
                        <b-row>
                            <b-col cols="12" sm="12" md="12">
                                <b-card :no-body="true" footer-class="px-3 py-2">
                                    <div slot="header">
                                        <strong>Post Code</strong>
                                    </div>
                                    <b-card-body class="p-3 clearfix">
                                        <b-row>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="postcodeText">Default Text</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.postcode_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.postcode_willUpdate">
                                                                <i :class="templateData.postcode_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input v-model="templateData.postcode" type="text" id="postcodeText" :disabled="!templateData.postcode_willUpdate"></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="postcodePosition">Position</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.postcode_position_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.postcode_position_willUpdate">
                                                                <i :class="templateData.postcode_position_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-select
                                                            id="postcodePosition"
                                                            v-model="templateData.postcode_position"
                                                            :plain="true"
                                                            :options="platePostCodePostions"
                                                            :disabled="!templateData.postcode_position_willUpdate"
                                                        ></b-form-select>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="postcodeFontSize">Font Size(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.postcode_font_size_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.postcode_font_size_willUpdate">
                                                                <i :class="templateData.postcode_font_size_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.postcode_font_size"
                                                            type="number"
                                                            class="form-control"
                                                            id="postcodeFontSize"
                                                            value="7"
                                                            min="0"
                                                            max="10"
                                                            :disabled="!templateData.postcode_font_size_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="postcodeRaiseBy">Raise By(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.postcode_raise_by_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.postcode_raise_by_willUpdate">
                                                                <i :class="templateData.postcode_raise_by_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.postcode_raise_by"
                                                            type="number"
                                                            id="postcodeRaiseBy"
                                                            value="0"
                                                            min="0"
                                                            :disabled="!templateData.postcode_raise_by_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="postcodeOffsetBy">Offset By(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.postcode_offset_by_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.postcode_offset_by_willUpdate">
                                                                <i :class="templateData.postcode_offset_by_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.postcode_offset_by"
                                                            type="number"
                                                            class="form-control"
                                                            id="postcodeOffsetBy"
                                                            value="0"
                                                            :disabled="!templateData.postcode_offset_by_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                    
                                                </b-form-group>
                                            </b-col>
                                        </b-row>                                          
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="12" md="12">
                                <b-card :no-body="true" footer-class="px-3 py-2">
                                    <div slot="header">
                                        <strong>Slogan</strong>
                                    </div>
                                    <b-card-body class="p-3 clearfix">
                                        <b-row>
                                            <b-col cols="12" sm="6">
                                                <b-form-group>
                                                    <label for="sloganText">Default Text</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.slogan_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.slogan_willUpdate">
                                                                <i :class="templateData.slogan_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input v-model="templateData.slogan" type="text" id="sloganText" :disabled="!templateData.slogan_willUpdate"></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="sloganFontSize">Font Size(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.slogan_font_size_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.slogan_font_size_willUpdate">
                                                                <i :class="templateData.slogan_font_size_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.slogan_font_size"
                                                            type="number"
                                                            class="form-control"
                                                            id="sloganFontSize"
                                                            value="7"
                                                            min="0"
                                                            max="10"
                                                            :disabled="!templateData.slogan_font_size_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="sloganRaiseBy">Raise By(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.slogan_raise_by_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.slogan_raise_by_willUpdate">
                                                                <i :class="templateData.slogan_raise_by_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.slogan_raise_by"
                                                            type="number"
                                                            id="sloganRaiseBy"
                                                            value="0"
                                                            min="0"
                                                            :disabled="!templateData.slogan_raise_by_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="sloganOffsetBy">Offset By(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.slogan_offset_by_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.slogan_offset_by_willUpdate">
                                                                <i :class="templateData.slogan_offset_by_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.slogan_offset_by"
                                                            type="number"
                                                            class="form-control"
                                                            id="sloganOffsetBy"
                                                            value="0"
                                                            :disabled="!templateData.slogan_offset_by_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>                                          
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="12" md="12">
                                <b-card :no-body="true" footer-class="px-3 py-2">
                                    <div slot="header">
                                        <strong>Border</strong>
                                    </div>
                                    <b-card-body class="p-3 clearfix">
                                        <b-row>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="onByDefault">On By Default</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.is_border_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.is_border_willUpdate">
                                                                <i :class="templateData.is_border_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-select
                                                            id="onByDefault"
                                                            v-model="templateData.is_border"
                                                            :plain="true"
                                                            :options="onOffOptions"
                                                            :disabled="!templateData.is_border_willUpdate"
                                                        ></b-form-select>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="borderWidth">Border Width(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.border_width_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.border_width_willUpdate">
                                                                <i :class="templateData.border_width_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.border_width"
                                                            type="number"
                                                            class="form-control"
                                                            id="borderWidth"
                                                            value="2"
                                                            min="1"
                                                            max="2"
                                                            :disabled="!templateData.border_width_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="borderMargin">Border Margin(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.border_margin_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.border_margin_willUpdate">
                                                                <i :class="templateData.border_margin_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.border_margin"
                                                            type="number"
                                                            id="borderMargin"
                                                            value="4"
                                                            min="1"
                                                            max="4"
                                                            :disabled="!templateData.border_margin_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>   
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="borderGap">Border Gap(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.border_gap_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.border_gap_willUpdate">
                                                                <i :class="templateData.border_gap_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.border_gap"
                                                            type="number"
                                                            class="form-control"
                                                            id="borderGap"
                                                            value="1"
                                                            min="0"
                                                            max="20"
                                                            :disabled="!templateData.border_gap_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>                                          
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" sm="12" md="12">
                                <b-card :no-body="true" footer-class="px-3 py-2">
                                    <div slot="header">
                                        <strong>BSAU</strong>
                                    </div>
                                    <b-card-body class="p-3 clearfix">
                                        <b-row>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="bsauOnByDefault">On By Default</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.is_bsau_mark_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.is_bsau_mark_willUpdate">
                                                                <i :class="templateData.is_bsau_mark_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-select
                                                            id="onByDefault"
                                                            v-model="templateData.is_bsau_mark"
                                                            :plain="true"
                                                            :options="onOffOptions"
                                                            :disabled="!templateData.is_bsau_mark_willUpdate"
                                                        ></b-form-select>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="3">
                                                <b-form-group>
                                                    <label for="bsauPrefix">Prefix</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.bsau_prefix_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.bsau_prefix_willUpdate">
                                                                <i :class="templateData.bsau_prefix_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input v-model="templateData.bsau_prefix" type="text" id="bsauPrefix" :disabled="!templateData.bsau_prefix_willUpdate"></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="bsauFontSize">Font Size(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.bsau_font_size_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.bsau_font_size_willUpdate">
                                                                <i :class="templateData.bsau_font_size_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.bsau_font_size"
                                                            type="number"
                                                            id="bsauFontSize"
                                                            value="5"
                                                            min="0"
                                                            :disabled="!templateData.bsau_font_size_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="bsauRaiseBy">Raise By(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.bsau_raise_by_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.bsau_raise_by_willUpdate">
                                                                <i :class="templateData.bsau_raise_by_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.bsau_raise_by"
                                                            type="number"
                                                            id="bsauRaiseBy"
                                                            value="5"
                                                            min="0"
                                                            :disabled="!templateData.bsau_raise_by_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group> 
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="2">
                                                <b-form-group>
                                                    <label for="bsauOffsetBy">Offset By(mm)</label>
                                                    <b-input-group>
                                                        <b-input-group-prepend>
                                                            <b-button :variant="templateData.bsau_offset_by_willUpdate ? 'success' : 'secondary'" :pressed.sync="templateData.bsau_offset_by_willUpdate">
                                                                <i :class="templateData.bsau_offset_by_willUpdate ? 'fa fa-check' : 'fa fa-minus'"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-input
                                                            v-model="templateData.bsau_offset_by"
                                                            type="number"
                                                            id="bsauOffsetBy"
                                                            value="2"
                                                            min="0"
                                                            :disabled="!templateData.bsau_offset_by_willUpdate"
                                                        ></b-form-input>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>                                          
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>
                        <hr/>
                        <b-row>
                            <b-col cols="12" sm="12" md="12">
                                <p>
                                    <b-button v-on:click="applyTemplate" variant="primary">
                                        <i class="fa fa-check"></i>&nbsp;Apply
                                    </b-button>&nbsp;
                                </p>
                                <b-alert v-if="dataEmptyError" variant="danger" show><strong>No data has been selected to apply</strong>
                                </b-alert>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'TemplateEditForm',
    emits: ['apply-data'],
    data () {
        return {
            templateData: {
                postcode: '',
                postcode_position: '',
                postcode_font_size: '',
                postcode_raise_by: '',
                postcode_offset_by: '',
                slogan: '',
                slogan_font_size: '',
                slogan_raise_by: '',
                slogan_offset_by: '',
                is_border: '',
                border_width: '',
                border_margin: '',
                border_gap: '',
                is_bsau_mark: '',
                bsau_prefix: '',
                bsau_font_size: '',
                bsau_raise_by: '',
                bsau_offset_by: '',
                postcode_willUpdate: false,
                postcode_position_willUpdate: false,
                postcode_font_size_willUpdate: false,
                postcode_raise_by_willUpdate: false,
                postcode_offset_by_willUpdate: false,
                slogan_willUpdate: false,
                slogan_font_size_willUpdate: false,
                slogan_raise_by_willUpdate: false,
                slogan_offset_by_willUpdate: false,
                is_border_willUpdate: false,
                border_width_willUpdate: false,
                border_margin_willUpdate: false,
                border_gap_willUpdate: false,
                is_bsau_mark_willUpdate: false,
                bsau_prefix_willUpdate: false,
                bsau_font_size_willUpdate: false,
                bsau_raise_by_willUpdate: false,
                bsau_offset_by_willUpdate: false
            },
            dataEmptyError: false,
            platePostCodePostions: [
                {value: 'Below', text: 'Below'},
                {value: 'Right', text: 'Right'}
            ],
            onOffOptions: [
                {value: 0, text: 'Off'},
                {value: 1, text: 'On'}
            ],
        }
    },
    computed: {
        isDataEmptyError() {
            let isError = true;
            const sourceData = JSON.parse(JSON.stringify(this.$data.templateData));

            Object.keys(sourceData).forEach(function(key) {
                if (key.includes('willUpdate')) {
                    if (sourceData[key] == true) {
                        isError = false;
                    }
                }
            });
            
            
            return isError;
        }
    },
    methods: {
        applyTemplate() {
            if (this.isDataEmptyError) {
                this.$data.dataEmptyError = this.isDataEmptyError;
            }
            else {
                let returnedTemplateData = {
                    postcode: '',
                    postcode_position: '',
                    postcode_font_size: '',
                    postcode_raise_by: '',
                    postcode_offset_by: '',
                    slogan: '',
                    slogan_font_size: '',
                    slogan_raise_by: '',
                    slogan_offset_by: '',
                    is_border: '',
                    border_width: '',
                    border_margin: '',
                    border_gap: '',
                    is_bsau_mark: '',
                    bsau_prefix: '',
                    bsau_font_size: '',
                    bsau_raise_by: '',
                    bsau_offset_by: '',
                    registration_number: ''
                };

                const sourceData = JSON.parse(JSON.stringify(this.$data.templateData));

                // prepare the data to be returned
                // we only want to return data that will be updated
                Object.keys(sourceData).forEach(function(key) {
                    if (key.includes('registration_number')) {
                        returnedTemplateData[key] = sourceData[key];
                    }
                    else if (sourceData[key] == '') {
                        console.log(key + ': ' + sourceData[key + '_willUpdate']);
                        if (sourceData[key + '_willUpdate'] === true) {
                            returnedTemplateData[key] = sourceData[key];
                        }
                        else {
                            delete returnedTemplateData[key];
                        }
                    }
                    else if (sourceData[key] !== '' && !key.includes('willUpdate')) {
                        returnedTemplateData[key] = sourceData[key];
                    }
                    // if (sourceData[key] == '' && !key.includes('registration_number')) {
                    //     delete returnedTemplateData[key];
                    // }
                });

                // send the data to the parent
                this.$emit('apply-data', returnedTemplateData);
            }
        }
    }
}
</script>
